import "./header.css";

function Header(){
    return(
        <div className="header">
        <div className="headertitle">
            <span className="headertitlesm">life</span>
            
        </div>
        <img className="headerimg" src="./assests/travel7.jpg" alt=""></img>
        </div>
    )
}
export default Header;